// extracted by mini-css-extract-plugin
export var dividerLine = "_9c-3";
export var itemImage = "_9c-9";
export var lightDivider = "_9c-4";
export var modalContent = "_9c-5";
export var modalContentCompact = "_9c-6";
export var productCard = "_9c-a";
export var productImage = "_9c-b";
export var productImageCompact = "_9c-7";
export var productImagePlaceholder = "_9c-c";
export var productImagePlaceholderCompact = "_9c-8";
export var progressBarBackground = "_9c-1";
export var progressBarContainer = "_9c-0";
export var progressBarFill = "_9c-2";